import template from './templates/dropdown-kt.tmpl.html';

export default function DropdownKT($document, $parse, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        template,
        scope: {
            options: '=options',
            model: '=model',
            details: '@',
            styling: '@',
            bool: '@',
            disabled: '=disabled',
        },
        link: function($scope, elem, attr) {
            $scope.id = attr.details;
            $scope.btnId = $scope.id + 'Menu';
            $scope.style = attr.styling;
            $scope.element = null;
            $scope.btn = null;
            $scope.opened = false;
            $scope.content = attr.content;
            $scope.bool = attr.bool;
            $scope.selected = null;
            $timeout(function() {
                $scope.element = angular.element('#' + $scope.id);
                $scope.btn = angular.element('#' + $scope.btnId);
            }, 100);
            $scope.$watch('model', function(newValue) {
                if (!angular.isObject(newValue)) {
                    const val = _.filter($scope.options, 'value', newValue.toString());
                    $scope.selected = val[0].text;
                    $scope.model = val[0].value === 'true';
                }
            });
            init();
            function init() {
                if (!angular.isObject($scope.model)) {
                        let value = $scope.model;
                        if (value === 0 || 1 || typeof value === 'boolean') {
                            value = $scope.model === 1 || value;
                        }
                            const val = _.filter($scope.options, 'value', value.toString());
                            $scope.selected = val[0].text;
                            $scope.model = val[0].value === 'true';
                }
            }
            $scope.setItem = function(item) {
                if ($scope.bool === 'true') {
                    $scope.selected = (item.text || item.Text);
                    $scope.model = item.value === 'true';
                } else {
                    $scope.selected = (item.text || item.Text);
                    $scope.model = item;
                }
                $scope.clickOutsideDropdown();
            };
            $scope.openDropdownMenu = function() {
                const element = angular.element(document).find('.travellers-dropdown.active');
                const body = angular.element(document).find('body');
                $timeout(() => {
                    body.addClass('dropdown-open');
                }, 400);
                $scope.element.toggleClass('active');
                $scope.btn.add('active');
                if ($scope.element.hasClass('active')) {
                    $scope.opened = true;
                    $scope.expanded = true;
                } else {
                    $scope.btn.remove('active');
                    $scope.opened = false;
                    $scope.expanded = false;
                }
                if (element.length === 0) {
                    body.removeClass('dropdown-open');
                }
            };
            $scope.clickOutsideDropdown = function() {
                if ($scope.element.hasClass('active') && $scope.opened) {
                    $scope.element.removeClass('active');
                    $scope.btn.removeClass('active');
                    $scope.opened = false;
                    $scope.expanded = false;
                }
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/dropdown-kt.directive.js